import { Block } from '@/components/block';
import { Heading } from '@/components/heading';
import { SimpleSchedules } from '@/components/schedules/simple';
import { Text } from '@/components/text';
import { SimpleScheduleInterface } from '@/types';
import { BlockId } from '@/types/block-types';

export interface SimpleScheduleBlockBlockProps {
  readonly id: BlockId;
  readonly carrierName: string;
  readonly carrierLongName: string;
  readonly schedules: SimpleScheduleInterface;
}

const SimpleScheduleBlock = ({ id, carrierName, carrierLongName, schedules }: SimpleScheduleBlockBlockProps) => {
  return (
    <Block id={id} className="bg-grey-50 !pt-0">
      <div className="relative z-3 -mx-3 mb-0 mt-12">
        <div className="mb-8 px-2">
          <Heading className="mb-2">{`${carrierName} schedules`}</Heading>
          <Text className="m-0">{`Upcoming vessel departures and sailing schedules for ${carrierLongName || carrierName}`}</Text>
        </div>
        <SimpleSchedules schedules={schedules} carrierName={carrierName} />
      </div>
    </Block>
  );
};

export { SimpleScheduleBlock };
